import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/views/Index'
// import FullScreenAd from '@/views/FullScreenAd'





import Check from '@/views/gateCheck/Check'
import HandCheck from '@/views/handCheck/HandCheck'

import Check2 from '@/views/gateCheck/Check2'
import HandCheck2 from '@/views/handCheck/HandCheck2'
import FaceCheck from '@/views/faceCheck/faceCheck'


//2018-11-30
import init from '@/views/init'


Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'Index',
            component: Index,
        },


        {
            path: '/check',
            name: 'check',
            component: Check,
        },
        {
            path: '/handCheck',
            name: 'handCheck',
            component: HandCheck,
        },
        {
            path: '/check2',
            name: 'check2',
            component: Check2,
        },
        {
            path: '/handCheck2',
            name: 'handCheck2',
            component: HandCheck2,
        },
        {
            path: '/faceCheck',
            name: 'faceCheck',
            component: FaceCheck,
        }


    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js